import { createClient } from '@supabase/supabase-js';

const supabaseUrl =
  import.meta.env.VITE_PUBLIC_SUPABASE_URL ||
  'https://idjpbbminfxofdfwhdtq.supabase.co';

const supabaseKey =
  import.meta.env.VITE_PUBLIC_SUPABASE_ANON_KEY ||
  'sb_publishable_FHcPPIkJaBn_wQpV4v2QMQ_2yr7Nlz6';

export { supabaseUrl };

export const supabase = createClient(supabaseUrl, supabaseKey, {
  auth: {
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: false,
  },
  global: {
    fetch: (...args) => {
      return fetch(...args).catch((err) => {
        // Silencia errores de red en refresh de token — no son fatales
        if (
          err instanceof TypeError &&
          err.message === 'Failed to fetch'
        ) {
          console.warn('[Supabase] Network error — token refresh skipped.');
          return new Response(JSON.stringify({ error: 'network_error' }), {
            status: 0,
            headers: { 'Content-Type': 'application/json' },
          });
        }
        throw err;
      });
    },
  },
});

// Cuando el token no puede renovarse (sesión expirada + sin red),
// limpia la sesión local para evitar bucles de error.
supabase.auth.onAuthStateChange((event) => {
  if (event === 'TOKEN_REFRESHED') return;
  if (event === 'SIGNED_OUT') {
    // Sesión cerrada — la UI reacciona via authGuard
  }
});